@let t = text();

<e-dialog [open]="open()" (openChange)="onOpenChange($event)" [title]="t.title" size="md">
  <ng-template>
    <div class="rave-new-year">
      <p class="rave-new-year__intro">{{ t.intro }}</p>

      <div class="rave-new-year__year" role="group" [attr.aria-label]="t.yearLabel">
        <button type="button" class="rave-new-year__step"
                [disabled]="(year() ?? minYear) <= minYear"
                [attr.aria-label]="t.previousYear" [title]="t.previousYear"
                (click)="shiftYear(-1)" data-test-id="rave-new-year-previous">
          <i class="fas fa-chevron-left" aria-hidden="true"></i>
        </button>
        <input class="rave-new-year__year-input" type="number" inputmode="numeric" step="1"
               [min]="minYear" [max]="maxYear" [value]="year() ?? ''"
               [attr.aria-label]="t.yearLabel"
               (change)="onYearInput($event)" data-test-id="rave-new-year-year" />
        <button type="button" class="rave-new-year__step"
                [disabled]="(year() ?? maxYear) >= maxYear"
                [attr.aria-label]="t.nextYear" [title]="t.nextYear"
                (click)="shiftYear(1)" data-test-id="rave-new-year-next">
          <i class="fas fa-chevron-right" aria-hidden="true"></i>
        </button>
      </div>

      <div class="rave-new-year__moment" data-test-id="rave-new-year-moment">
        <span class="rave-new-year__moment-label">{{ t.momentLabel }}</span>
        @if (momentLoading()) {
          <span class="rave-new-year__moment-value rave-new-year__moment-value--muted">
            <i class="fas fa-circle-notch fa-spin" aria-hidden="true"></i>
            {{ t.loading }}
          </span>
        } @else if (momentMissing()) {
          <span class="rave-new-year__moment-value rave-new-year__moment-value--error">{{ t.notFound }}</span>
        } @else {
          <span class="rave-new-year__moment-value">{{ momentText() }}</span>
        }
      </div>

      <div class="rave-new-year__actions">
        <button eBtn color="highlight" [icon]="icons.full" iconColor="primary-75"
                [disabled]="momentText() == null" [tooltip]="t.fullTooltip"
                (click)="choose('full')" data-test-id="rave-new-year-full">{{ t.full }}</button>
        <button eBtn color="highlight" [icon]="icons.transit" iconColor="primary-75"
                [disabled]="momentText() == null" [tooltip]="t.transitTooltip"
                (click)="choose('transit')" data-test-id="rave-new-year-transit">{{ t.transit }}</button>
      </div>
    </div>
  </ng-template>
</e-dialog>
